// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2H2dR","col":"Table_col__3EEqp","fulfillmentStatus":"Table_fulfillmentStatus__1piU7","emailCol":"Table_emailCol__1KaHB"};